import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AddCookware = ({ show, onClose, refresh }) => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const user_id = parseInt(localStorage.getItem("user_id"), 10);

    const [selCatego, setSelCatego] = useState(null);
    const [selSubCatego, setSubSelCatego] = useState(null);
    const [selMaterial, setMaterial] = useState(null);
    const [count, setcount] = useState(null);
    const [size, setsize] = useState('');
    const [capacity, setcapacity] = useState('');
    const [cookwareName, setCookName] = useState('');
    const [description, setDescription] = useState('');
    const [errors, setErrors] = useState({});

    const [categoryOPT, setCategoOPt] = useState([]);
    useEffect(() => {
        const fetchLeadTypes = async () => {
            try {
                const response = await axios.get(`${baseURL}/cookware_category/get_active`);
                const formatted = response.data.map(item => ({
                    value: item.sno,
                    label: item.category_name,
                }));
                setCategoOPt(formatted);
            } catch (error) {
                console.log('Error fetching data:', error);
            }
        };

        fetchLeadTypes();
    }, []);

    const [data_name, setData] = useState([]);
    useEffect(() => {
        axios.get(`${baseURL}/cookwares/getall`)
            .then(response => {
                setData(response.data.map(mode => mode.cookware_name.toLowerCase()));
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
            });
    }, []);

    const [subCatego, setSubcatgo] = useState([]);
    useEffect(() => {
        const fetchLeadTypes = async () => {
            try {
                const response = await axios.get(`${baseURL}/cookware_sub_category/get_depts/${selCatego}`);
                const formatted = response.data.map(item => ({
                    value: item.sno,
                    label: item.subcategory_name,
                }));
                setSubcatgo(formatted);
            } catch (error) {
                console.log('Error fetching lead types:', error);
            }
        };

        if (selCatego) {
            fetchLeadTypes();
        }
    }, [selCatego]);

    const [materialOPt, setMaterialOPt] = useState([]);
    useEffect(() => {
        const fetchLeadTypes = async () => {
            try {
                const response = await axios.get(`${baseURL}/cookware_material/get_active`);
                const formatted = response.data.map(item => ({
                    value: item.sno,
                    label: item.material_name,
                }));
                setMaterialOPt(formatted);
            } catch (error) {
                console.log('Error fetching lead types:', error);
            }
        };

        fetchLeadTypes();
    }, []);

    const [SizeChecked, setSizeChecked] = useState(false);
    const [CapacityChecked, setCapacityChecked] = useState(false);

    const formatName = (name) => {
        return name.charAt(0).toUpperCase() + name.slice(1);
    };

    const validate = () => {
        const newErrors = {};
        // const regex = /[^a-zA-Z0-9\s-]+$/;

        if (!cookwareName.trim()) {
            newErrors.name = "This Field is Required.";
        } else if (data_name.includes(cookwareName.trim().toLowerCase())) {
            newErrors.name = "This Name Already Exists";
        }

        if (!selCatego) {
            newErrors.catego = "This Field is Required.";
        }

        if (!selSubCatego) {
            newErrors.subcatego = "This Field is Required.";
        }

        if (!selMaterial) {
            newErrors.material = "This Field is Required.";
        }

        if (!count) {
            newErrors.count = "This Field is Required.";
        }

        if (SizeChecked) {
            if (!size) {
                newErrors.size = "This Field is Required.";
            }
        }

        if (CapacityChecked) {
            if (!capacity) {
                newErrors.capacity = "This Field is Required.";
            }
        }

        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const postData = {
            category_id: selCatego,
            sub_category_id: selSubCatego,
            material_id: selMaterial,
            cookware_name: cookwareName,
            cookware_count: count,
            cookware_size: size,
            cookware_capacity: capacity,
            description: description,
            created_by: user_id
        };

        axios.post(`${baseURL}/cookwares`, postData)
            .then(response => {
                onClose();
                refresh();
                toast.success("Cookware Created Successfully!");
            }).catch(error => {
                onClose();
                console.log(error);
                toast.error("Cookware Creation Failed");
            });
    };

    return (
        <Modal show={show} size="lg">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Create Cookware</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">Cookware Category<span className="required">*</span></label>
                            <Select placeholder="Select Cookware Category"
                                options={categoryOPT}
                                onChange={(e) => setSelCatego(e.value)}
                            />
                            {errors.catego && (<div className="text-danger">{errors.catego}</div>)}
                        </div>
                        <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">Cookware Subcategory<span className="required">*</span></label>
                            <Select placeholder="Select Cookware Subcategory"
                                options={subCatego}
                                onChange={(e) => setSubSelCatego(e.value)}
                            />
                            {errors.subcatego && (<div className="text-danger">{errors.subcatego}</div>)}
                        </div>
                        <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">Cookware<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Cookware"
                                maxLength={100}
                                value={cookwareName}
                                onChange={(e) => {
                                    const onlyAlphabets = e.target.value.replace(/[^a-zA-Z0-9\s-]/g, '');
                                    setCookName(formatName(onlyAlphabets));
                                }}
                            />
                            {errors.name && (<div className="text-danger">{errors.name}</div>)}
                        </div>
                        <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">Cookware Material<span className="required">*</span></label>
                            <Select placeholder="Select Cookware Material"
                                options={materialOPt}
                                onChange={(e) => setMaterial(e.value)}
                            />
                            {errors.material && (<div className="text-danger">{errors.material}</div>)}
                        </div>
                        <div className="col-lg-6 mb-2">
                            <div className='row mb-2'>
                                <div className="col-lg-6">
                                    <div className="form-check custom-checkbox">
                                        <input
                                            type="checkbox"
                                            className="form-check-input me-3"
                                            id="SizeCheck"
                                            checked={SizeChecked}
                                            onChange={() => setSizeChecked(!SizeChecked)}
                                        />
                                        <label className="text-black font-w500 fs-7" htmlFor="SizeCheck">Size{SizeChecked ? <span className="required">*</span> : ''}</label>
                                    </div>
                                    <div className={SizeChecked ? 'd-block' : 'd-none'}>
                                        <div className='col-lg-12'>
                                            <input type="text" className="form-control" placeholder="Enter Size"
                                                maxLength={100}
                                                value={size}
                                                onChange={(e) => {
                                                    const onlyAlphabets = e.target.value.replace(/[^a-zA-Z0-9\s-]/g, '');
                                                    setsize(onlyAlphabets);
                                                }}
                                            />
                                            {errors.size && (<div className="text-danger">{errors.size}</div>)}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="form-check custom-checkbox">
                                        <input
                                            type="checkbox"
                                            className="form-check-input me-3"
                                            id="CapacityCheck"
                                            checked={CapacityChecked}
                                            onChange={() => setCapacityChecked(!CapacityChecked)}
                                        />
                                        <label className="text-black font-w500 fs-7" htmlFor="CapacityCheck">Capacity{CapacityChecked ? <span className="required">*</span> : ''}</label>
                                    </div>
                                    <div className={CapacityChecked ? 'd-block' : 'd-none'}>
                                        <div className='col-lg-12'>
                                            <input type="text" className="form-control" placeholder="Enter Capacity"
                                                maxLength={100}
                                                value={capacity}
                                                onChange={(e) => {
                                                    const onlyAlphabets = e.target.value.replace(/[^a-zA-Z0-9\s-]/g, '');
                                                    setcapacity(onlyAlphabets);
                                                }}
                                            />
                                            {errors.capacity && (<div className="text-danger">{errors.capacity}</div>)}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">Cookware Count<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Count"
                                maxLength={10}
                                value={count}
                                onChange={(e) => {
                                    const onlyAlphabets = e.target.value.replace(/[^0-9\s]/g, '');
                                    setcount(onlyAlphabets);
                                }}
                            />
                            {errors.count && (<div className="text-danger">{errors.count}</div>)}
                        </div>
                        <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <textarea rows={8} className="form-control" name="comment" placeholder="Description"
                                maxLength={250}
                                value={description}
                                onChange={(e) => setDescription(formatName(e.target.value))}
                            />
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Create Cookware <i className="fas fa-angle-double-right ms-2"></i></Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default AddCookware;
